<template>
  <section class="w-full relative bg-[#FCF9F0]" id="values">
    <div
      class="w-full max-w-7xl mx-auto [@media(max-width:1280px)]:px-[60px] pt-[40px] pb-[120px] grid gap-4 grid-cols-1 lg:grid-cols-[68%_1fr]"
    >
      <div class="flex flex-col">
        <div class="text-[36px] font-semibold">Faith Made Personal and Practical</div>
        <div class="text-[16px] text-[#219A6A] leading-[1.5] mt-[15px]">
          Women’s Bible is a community and a daily faith journey. Designed for modern Christian women, it nurtures prayer habits, builds biblical
          knowledge, and connects hearts through encouragement and Scripture.
        </div>
        <div class="custom-collapse w-full mt-[30px] flex">
          <el-collapse class="w-full" v-model="activeName" accordion>
            <el-collapse-item class="border-0 border-b-0" :name="item.id" v-for="item in data" :key="item.id">
              <template #title>
                <div class="w-[100%] flex items-center text-[18px] font-[600] leading-none">
                  <img :src="item.iconUrl" class="w-[26px]" alt="close" />
                  <div
                    class="ml-[28px] mr-[28px] pl-[8px] pr-[8px] bg-[#FFFFFF] rounded-[4px] flex-1 text-left text-[24px] tracking-[0] leading-[32px]"
                  >
                    {{ item.title }}
                  </div>
                  <img v-show="item.id === activeName" src="@/assets/imgs/pageValues/close.png" class="w-[18px]" alt="close" />
                  <img v-show="item.id !== activeName" src="@/assets/imgs/pageValues/open.png" class="w-[18px]" alt="open" />
                </div>
              </template>
              <div class="pl-[53px] pr-[30px] border-0 border-b-0">
                <div class="text-[16px] text-[#666666] mt-[16px] flex align-self" v-for="(it, index) in item.desc" :key="index">
                  <svg
                    class="w-[8px] h-[8px] flex-shrink-0 mr-[8px] mt-[6px]"
                    viewBox="0 0 12 12"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <!-- reduce radius so the circle has a small padding inside the viewBox -->
                    <circle cx="4" cy="4" r="3" fill="#FCC853" />
                  </svg>
                  {{ it }}
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="w-full aspect-[11/19] relative pr-[16px] lg:pr-[60px]">
        <img
          v-show="!activeName"
          src="@/assets/imgs/pageValues/default.png"
          class="w-full h-full object-contain relative z-10"
          alt="values image demo"
        />
        <img
          v-for="item in data"
          :key="item.id"
          v-show="activeName === item.id"
          :src="item.imgUrl"
          alt="values image demo"
          class="w-full h-full object-contain relative z-10"
          :class="{ active: activeName === item.id }"
        />
      </div>
    </div>

    <img class="absolute bottom-[-1px] right-0 w-full" src="@/assets/imgs/bl4.png" alt="decor" />
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import value1PhoneImg from '@/assets/imgs/pageValues/value1.png'
import value2PhoneImg from '@/assets/imgs/pageValues/value2.png'
import value3PhoneImg from '@/assets/imgs/pageValues/value3.png'

import value1IconImg from '@/assets/imgs/pageValues/icon1.png'
import value2IconImg from '@/assets/imgs/pageValues/icon2.png'
import value3IconImg from '@/assets/imgs/pageValues/icon3.png'

const activeName = ref('1') // 默认不展开任何面板，显示默认图片

const data = [
  {
    id: '1',
    imgUrl: value1PhoneImg,
    iconUrl: value1IconImg,
    alt: 'spiritual',
    title: 'Spiritual Growth Every Day',
    desc: [
      'Consistent Devotion — With daily devotionals and guided prayers, Women’s Bible helps you stay rooted in God’s Word no matter how busy life gets.',
      'Scripture in Action — Each feature points you back to Scripture, helping you apply biblical truths to relationships, emotions, and everyday challenges.',
    ],
  },
  {
    id: '2',
    imgUrl: value2PhoneImg,
    iconUrl: value2IconImg,
    alt: 'learning',
    title: 'A Caring Community of Faith',
    desc: [
      'Shared Encouragement — The Assist feature allows women to share prayer needs and offer biblical encouragement — a space to love and be loved in Christ.',
      'Safe and Uplifting — Every message is shaped by empathy and faith, creating a nurturing space for women who want to grow together, not alone.',
    ],
  },
  {
    id: '3',
    imgUrl: value3PhoneImg,
    iconUrl: value3IconImg,
    alt: 'peace',
    title: 'Learning Through Joy',
    desc: [
      'Interactive Bible Quizzes — Studying Scripture doesn’t have to feel heavy. Our quiz section turns learning into a joyful experience that strengthens memory and confidence in God’s Word.',
      'Motivating Faith Habit — Small wins in quizzes and readings motivate users to stay consistent in their spiritual journey.',
    ],
  },
]
</script>
<style lang="less" scoped>
.custom-collapse {
  :deep(.el-collapse) {
    /* remove outer border of the collapse container */
    border: none !important;
    box-shadow: none !important;

    /* remove top and bottom separators if present */
    border-top: none !important;
    border-bottom: none !important;
    .el-collapse-item__arrow {
      svg,
      i {
        display: none !important;
      }
    }

    .el-collapse-item {
      /* remove individual item borders (including first/last) */
      border: none !important;
      box-shadow: none !important;

      .el-collapse-item__header {
        border: none !important;
        background-color: rgba(0, 0, 0, 0);
        margin-top: 0px;
      }
      .ed .el-collapse-item__content {
        padding-bottom: 40px;
      }
      .el-collapse-item__wrap {
        border: none !important;
        background-color: rgba(0, 0, 0, 0);
      }
    }
    .el-collapse-item:nth-of-type(1) {
      .el-collapse-item__header {
        margin-top: 0;
      }
    }
  }
}
</style>
